import { useResponsiveMode } from '@uifabric/portal-ux/lib/styling/useResponsiveMode';
import * as React from 'react';
import { ConnectedPersonBadge } from './ConnectedPersonBadge';
export const ResponsiveConnectedPersonBadge: React.FC = () => {
  const responsiveMode = useResponsiveMode();
  return <ConnectedPersonBadge responsiveMode={responsiveMode} />;
};
